import { useState, useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, setToken, removeToken, getToken } from '@/lib/api';

export function useAuth() {
  const queryClient = useQueryClient();
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!getToken());

  const loginMutation = useMutation({
    mutationFn: ({ username, password }: { username: string; password: string }) =>
      api.auth.login(username, password),
    onSuccess: (data: any) => {
      setToken(data.data.token);
      setIsAuthenticated(true);
      queryClient.setQueryData(['user'], data.data.user);
    },
  });

  const logoutMutation = useMutation({
    mutationFn: () => api.auth.logout(),
    onSettled: () => {
      removeToken();
      setIsAuthenticated(false);
      queryClient.clear();
    },
  });

  const login = useCallback(
    (username: string, password: string) => {
      return loginMutation.mutateAsync({ username, password });
    },
    [loginMutation],
  );

  const logout = useCallback(() => {
    return logoutMutation.mutateAsync();
  }, [logoutMutation]);

  return {
    isAuthenticated,
    login,
    logout,
    isLoggingIn: loginMutation.isPending,
    isLoggingOut: logoutMutation.isPending,
    error: loginMutation.error,
  };
}
